import { Color } from '@kite-js/theme-types';

const green: Color = {
    50: '#dbe9dd',
    100: '#93bd9a',
    200: '#6fa778',
    300: '#4b9156',
    400: '#377d42',
    500: '#336a3b',
};

export default green;
